<template>
<div id="users" class="content">  
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <router-link :to="`/${$i18n.locale}/user/new`"><img src="../../assets/images/add_record.png" style="height: 22px; margin-bottom: 5px;"></router-link>
                <!--a href="" style="margin-left: 20px;"><u>IMPORT</u></a-->

                <a href="" @click.prevent="printPDF()" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left: 8px"></a>
                <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>

            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <v-data-table
                    :headers="headers"
                    :items="admins"
                    :pagination.sync="pagination"
                    class="elevation-1 fixed-header"
                >
                    <template slot="items" slot-scope="props">
                        <td class="justify-center layout px-0">
                            <v-icon
                                small
                                class="mr-2 pt-3"
                                @click="redirectTo('/' + $i18n.locale + '/user/edit/' + props.item.id)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                small
                                class="pt-3"
                                @click="deleteAdminUser(props.item, props.item.id, props.item.display_name)"
                            >
                                delete
                            </v-icon>
                        </td>
                        <td class="text-xs-left">{{ props.item.display_name }}</td>
                        <td class="text-xs-left">{{ props.item.email }}</td>
                        <td class="text-xs-left">{{ props.item.effective_at | formatDate }}</td>
                        <td class="text-xs-left">{{ props.item.effective_till | formatDate }}</td>
                        <td class="text-xs-center">{{ props.item.is_enabled | toggleIsEnabled }}</td>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                    </template>
                </v-data-table>
            </div>           
        </div>

</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

export default {
    data () {
        return {
            title: 'ADMIN USERS',
            headers: [
                    { text: 'ACTION', sortable: false, value: 'action' },
                    { text: 'FULL NAME', value: 'display_name' },
                    { text: 'EMAIL', value: 'email' },
                    { text: 'VALID FROM', value: 'effective_at' },
                    { text: 'VALID UNTIL', value: 'effective_till' },
                    { text: 'DISABLED', value: 'is_enabled' },
            ],            
            admins: [],
            pagination: {'sortBy': 'effective_at', 'descending': true, 'rowPerPage': -1},
        }
    },

    methods: {
        loadAdmins() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/admin/list')
            .then(function (response) {
                vm.admins = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        deleteAdminUser(item, id, name) {
            var vm = this
            const index = vm.admins.indexOf(item)

            if(confirm('Are you sure you want to delete ' + name + '?')) {
                axios.delete(this.$store.getters.rootAPI + '/admin/' + id)
                .then(function (response) {
                    if (response.data.status === "error") {
                        alert("Cannot delete delete user " + name + " because it is in used!")
                    } else {
                        vm.admins.splice(index, 1)
                    }                    
                })
                .catch(function (error) {
                    alert('An error occured.')
                })
            }
        },

        redirectTo(path) {
            this.$router.push(path)
        },
        
        enableToggle(value) {
            if (value === 0) {
                return 'Y'
            } else {
                return 'N'
            }                 
        },

        yesNoToggle(value) {
            if (value === 0) {
                return 'N'
            } else {
                return 'Y'
            }                 
        },

        checkNullVal(value) {
            if (!value) {
                return ''
            } else  {
                return value
            }
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.admins
            let data = []

            for (var i = 0; i < item.length; i++) {
                data.push({
                    FULL_NAME: item[i].display_name,
                    EMAIL: item[i].email,
                    VALID_FROM: moment(item[i].effective_at).format('YYYY-MM-DD'),
                    VALID_UNTIL: moment(item[i].effective_till).format('YYYY-MM-DD'),
                    DISABLED: this.enableToggle(item[i].is_enabled),
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.admins

            var head = [                
                { title: 'FULL NAME', dataKey: 'display_name' },
                { title: 'EMAIL', dataKey: 'email' },
                { title: 'VALID FROM', dataKey: 'effective_at' },
                { title: 'VALID UNTIL', dataKey: 'effective_till' },
                { title: 'DISABLED', dataKey: 'is_enabled' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({                        
                        display_name: item[i].display_name,
                        email: item[i].email,
                        effective_at: moment(item[i].effective_at).format('YYYY-MM-DD'),
                        effective_till: moment(item[i].effective_till).format('YYYY-MM-DD'),
                        is_enabled: this.enableToggle(item[i].is_enabled),
                    })
            }
            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },

    created() {
        this.loadAdmins();
    }

  
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/user/Users.vue